// extracted by mini-css-extract-plugin
export default {"button":"ReviewSynthesis_button__sfXCi","button__collapseIcon":"ReviewSynthesis_button__collapseIcon__ObKwZ"};